/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import useStore from '../../../services/hooks/useStore';
import { observer, useLocalStore } from 'mobx-react-lite';
import useModal from '../../../services/hooks/useModal';
import syncModel from '../../../services/models/Sync';
import { api, apiV2 } from '../../../services/utils';
import { Body } from '../../../components/Body';
import Display from '../../../components/Tabela/Display';
import { Info } from '../../../components/Historico/styles';
import Formatter from '../../../services/Formatter';
import { returnEspecie, returnFase } from '../../../services/utils/propriedade';
import { evaluate } from 'mathjs';
import Botao from '../../../components/Botoes/Botao';
import Historico from '../../../components/HistoricoV2';
import Confirmar from '../../../components/Modais/Confirmar';
import { permissoes } from '../../../services/utils/permissoes';
import EditarBancada from './EditarBancada';

const HistoricoBancada: React.FC = () => {
  const { id }: { id: string } = useParams();

  const location: any = useLocation();
  const store = useStore();
  const history = useHistory();
  const state = useLocalStore(() => ({
    tanque: store.tanques.arr ? store.tanques.get(parseInt(id)) : null,
    historico: {} as Historico2,
    historico2: {},
    sync: false,
  }));
  const modalExclusao = useModal();
  const modalEditar = useModal();
  const temPermissaoEscrita = store.checkPermissions(permissoes.PROPRIEDADE_ESCRITA);

  async function sync(): Promise<void> {
    await syncModel.historicoTanque();
    state.sync = true;
    store.toggleLoader();

    await apiV2
      .get(`/tanque/list-historico/${id}/`, {
        params: {
          propriedade: store.propriedade!.id,
        },
      })
      .then((res: any) => {
        state.tanque = res.data;
      });
    if (state.tanque) {
      state.historico2 = (await store.tanques.getHistorico2(parseInt(id), store.propriedade!.id)) as never;
    } else {
      history.push('/propriedade/tanques');
    }

    store.toggleLoader();
  }

  async function excluir(bancadaID: number): Promise<void> {
    const historico = await store.tanques.getHistorico(bancadaID);

    if (historico) {
      if (historico?.length > 0) {
        store.notificar('A bancada possui histórico e não pode ser deletado!');
      } else {
        store.toggleLoader();
        await api.delete(`/tanques/${bancadaID}/?propriedade=${store.propriedade!.id}`);
        store.notificar('Bancada excluída com sucesso!');
        history.push({
          pathname: '/propriedade/bancadas',
          state: { page: location.state ? location.state.page : null },
        });
        store.toggleLoader();
      }
    }
  }
  React.useEffect(() => {
    if (store.propriedade) {
      sync();
    }
  }, []);

  // Filtra so lotes finalizado para mostrar o peso médio do tanque
  const lote = state.tanque?.lotes.filter((lote) => lote.fase_lote.slug !== 'finalizado' && lote.estoque);

  return state.sync ? (
    <Body gridColumns="350px 1fr">
      <div>
        {state.tanque && state.tanque.lotes.length ? (
          <Display
            back={() =>
              history.push({
                pathname: '/propriedade/bancadas',
                state: { page: location.state ? location.state.page : null },
              })
            }
            title={state.tanque?.nome || ''}
          >
            <Info>
              <b>Nome:</b> {state.tanque?.nome ? state.tanque.nome : 'Sem nome'}
            </Info>
            <Info>
              <b>Tamanho (m²/m³):</b> {Formatter.formatNumber(2, state.tanque?.tamanho) || 0}
            </Info>
            <Info>
              <b>Capacidade (Kg):</b> {Formatter.formatNumber(3, state.tanque?.capacidade) || 0}
            </Info>
            <Info>
              <b>Origem da água:</b> {state.tanque?.agua_origem.nome}
            </Info>
            <Info>
              <b>Tipo:</b> {state.tanque?.tanque_tipo.nome}
            </Info>
            <Info>
              <b>Espécie:</b> {state.tanque && returnEspecie(state.tanque.estoque, state.tanque.lotes)}
            </Info>
            <Info>
              <b>Lote:</b>{' '}
              {state.tanque && state.tanque.lotes.length
                ? state.tanque.lotes.map((lote) => lote.codigo).join(', ')
                : 'Sem Lote'}
            </Info>
            <Info>
              <b>Fase:</b> {state.tanque && returnFase(state.tanque.estoque, state.tanque.lotes)}
            </Info>
            <Info>
              <b>Peso médio (g):</b>{' '}
              {state.tanque &&
                Formatter.formatNumber(
                  3,
                  state.tanque
                    ? lote?.reduce((prev, next: any) => {
                        return prev + next.peso_medio;
                      }, 0)
                    : 0,
                )}
            </Info>
            <Info>
              <b>Qtd de animais:</b> {state.tanque ? Formatter.formatNumber(0, state.tanque.estoque) : 0}
            </Info>
            <Info>
              <b>Biomassa (Kg):</b>{' '}
              {state.tanque &&
                Formatter.formatNumber(
                  3,
                  state.tanque.estoque
                    ? lote?.reduce((prev, next: any) => {
                        return prev + evaluate(`(${next.peso_medio} * ${state.tanque?.estoque}) / 1000`);
                      }, 0)
                    : 0,
                )}
            </Info>
          </Display>
        ) : (
          <Display
            back={() =>
              history.push({
                pathname: '/propriedade/tanques',
                state: { page: location.state ? location.state.page : null },
              })
            }
            title={state.tanque?.nome || state.tanque?.codigo || ''}
          >
            <Info>
              <b>Nome:</b> {state.tanque?.nome ? state.tanque.nome : 'Sem nome'}
            </Info>
            <Info>
              <b>Tamanho (m²/m³):</b> {Formatter.formatNumber(2, state.tanque?.tamanho) || 0}
            </Info>
            <Info>
              <b>Capacidade (Kg):</b> {Formatter.formatNumber(3, state.tanque?.capacidade) || 0}
            </Info>
            <Info>
              <b>Origem da água:</b> {state.tanque?.agua_origem.nome}
            </Info>
            <Info>
              <b>Tipo:</b> {state.tanque?.tanque_tipo.nome}
            </Info>
            <Info>
              <b>Espécie:</b> {state.tanque && returnEspecie(state.tanque.estoque, state.tanque.lotes)}
            </Info>
            <Info>
              <b>Lote:</b>{' '}
              {state.tanque && state.tanque.lotes.length
                ? state.tanque.lotes.map((lote) => lote.codigo).join(', ')
                : 'Sem Lote'}
            </Info>
            <Info>
              <b>Fase:</b> {state.tanque && returnFase(state.tanque.estoque, state.tanque.lotes)}
            </Info>
            <Info>
              <b>Peso médio (g):</b>{' '}
              {state.tanque &&
                Formatter.formatNumber(
                  3,
                  state.tanque
                    ? lote?.reduce((prev, next: any) => {
                        return prev + next.peso_medio;
                      }, 0)
                    : 0,
                )}
            </Info>
            <Info>
              <b>Qtd de animais:</b> {state.tanque ? Formatter.formatNumber(0, state.tanque.estoque) : 0}
            </Info>
            <Info>
              <b>Biomassa (Kg):</b>{' '}
              {state.tanque &&
                Formatter.formatNumber(
                  3,
                  state.tanque.estoque
                    ? lote?.reduce((prev, next: any) => {
                        return prev + evaluate(`(${next.peso_medio} * ${state.tanque?.estoque}) / 1000`);
                      }, 0)
                    : 0,
                )}
            </Info>
          </Display>
        )}

        <div style={{ margin: '0 10px', display: 'flex' }}>
          <Botao disabled={!temPermissaoEscrita} onClick={() => modalExclusao.open()} variant="contained" cor="#FC7467">
            Excluir
          </Botao>
          <Botao disabled={!temPermissaoEscrita} onClick={modalEditar.open} variant="contained" cor="#00C853">
            Editar
          </Botao>
        </div>
      </div>

      <Display heightOffset="80px" title="Histórico da bancada" sync={sync}>
        {state.historico2 && Object.keys(state.historico2).length ? (
          <Historico historico={state.historico2 as Historico2} sync={sync} />
        ) : (
          <p style={{ width: '100', textAlign: 'center', margin: '10px' }}>
            Não existe nenhum registro para esse lote!
          </p>
        )}
      </Display>

      <Confirmar
        title="Tem certeza que deseja excluir?"
        open={modalExclusao.state}
        handleClose={modalExclusao.close}
        onCancel={modalExclusao.close}
        onConfirm={() => {
          modalExclusao.close();
          excluir(parseInt(id));
        }}
      />
      {state.tanque && (
        <EditarBancada open={modalEditar.state} bancada={state.tanque} handleClose={modalEditar.close} />
      )}
    </Body>
  ) : null;
};

export default observer(HistoricoBancada);
